import { Model } from "pinia-orm";
import Role from "./Role";
import Contributor from "./Contributor";
import Company from "./Company";
import { Batch } from "./Batch";
import Mission from "../Mission";

export default class CompanyProjectRole extends Model {
  static name = "CompanyProjectRole";
  static entity = "companyProjectRoles";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(),
      companyId: this.attr(null),
      projectId: this.attr(null),
      roleId: this.attr(null),
      contributors: this.hasMany(Contributor, "companyProjectRoleId"),
      batchesUuids: this.attr(null),
      batches: this.hasManyBy(Batch, "batchesUuids", "uuid"),
      company: this.belongsTo(Company, "companyId"),
      project: this.belongsTo(Mission, "projectId"),
      role: this.belongsTo(Role, "roleId"),
      roleAlias: this.attr(null),
      workDone: this.attr(null),
      projectedStaffing: this.attr(null),
      isArchived: this.attr(false),
    };
  }
}
